//判断两数组元素是否相同
export function isSameArr(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }
    return arr1.every((item) => arr2.includes(item));
}
